/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs */

const en_svc_ai_image_pod_automation_comply_desc6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trademark and copyright screening plus platform AI-disclosure rules handled.`)
};

const ar_svc_ai_image_pod_automation_comply_desc6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فحص العلامات وحقوق النشر إضافة إلى قواعد الإفصاح عن الذكاء الاصطناعي، كلها مُغطاة.`)
};

const bn_svc_ai_image_pod_automation_comply_desc6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ট্রেডমার্ক ও কপিরাইট স্ক্রিনিংসহ প্ল্যাটফর্মের এআই-ঘোষণা নিয়ম, সব সামলানো।`)
};

const de_svc_ai_image_pod_automation_comply_desc6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marken- und Urheberrechtsprüfung plus Plattformregeln zur KI-Kennzeichnung sind abgedeckt.`)
};

const es_svc_ai_image_pod_automation_comply_desc6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrado de marcas y derechos de autor más reglas de declaración de IA de cada plataforma, gestionados.`)
};

const fr_svc_ai_image_pod_automation_comply_desc6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrage marques et droits d'auteur plus règles de mention IA des plateformes, pris en charge.`)
};

const pt_svc_ai_image_pod_automation_comply_desc6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtragem de marcas e direitos de autor e regras de declaração de IA de cada plataforma.`)
};

const zh_svc_ai_image_pod_automation_comply_desc6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商标版权筛查，外加各平台的 AI 声明规则，全部搞定。`)
};

const tr_svc_ai_image_pod_automation_comply_desc6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marka ve telif taraması artı platform YZ bildirim kuralları, hepsi halledilir.`)
};

const ru_svc_ai_image_pod_automation_comply_desc6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка товарных знаков и копирайта плюс правила маркировки ИИ площадок, всё закрыто.`)
};

const pl_svc_ai_image_pod_automation_comply_desc6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weryfikacja znaków towarowych i praw autorskich plus platformowe reguły oznaczania AI, wszystko załatwione.`)
};

/**
* | output |
* | --- |
* | "Trademark and copyright screening plus platform AI-disclosure rules handled." |
*
* @param {Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_comply_desc6 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Comply_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_comply_desc6(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_comply_desc6(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_comply_desc6(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_comply_desc6(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_comply_desc6(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_comply_desc6(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_comply_desc6(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_comply_desc6(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_comply_desc6(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_comply_desc6(inputs)
	return en_svc_ai_image_pod_automation_comply_desc6(inputs)
});
export { svc_ai_image_pod_automation_comply_desc6 as "svc_ai-image-pod-automation_COMPLY_desc" }